export const AMOUNT_OF_MOBILE_HEIGHT_MENU = 64;
export const TEST_RIDE_GRID_WRAPPER = 'TestRideGridWrapper';
